import { useState, useEffect, useContext } from "react"
// import { useSelector } from "react-redux"
import axios from "axios"


import CRUDTable from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable"
import CRUDTableHeader from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader"
import CRUDth from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth"
import CRUDTableRow from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow"
import ShortTextCell from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell"
import ViewButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ViewButton/ViewButton"
import Modal from "../../../Partials/Elements/Modal/Modal"
import CRUDDeleteBoilerPlate from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDeleteBoilerPlate/CRUDDeleteBoilerPlate"
import { ORDERS_API } from "../../../../Utilities/APIs/APIs"
import ViewOrder from "../../OrderScreens/ViewOrder"
import { takaFormatter } from "../../../../Utilities/Formatter"
import AuthContext from "../../../../Context/AuthContext"
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance"



function DailyReports() {

    const [dailyReports, setDailyReports] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [targetID, setTargetID] = useState(null)
    const [showViewSection, setShowViewSection] = useState(false)
    const [showCreateForm, setShowCreateForm] = useState(false)
    const [showUpdateForm, setShowUpdateForm] = useState(false)
    const [showDeleteSection, setShowDeleteSection] = useState(false)
    const [toggleFetch, setToggleFetch] = useState(false)

    const { employee } = useContext(AuthContext)
    // const navigate = useNavigate()
    const ordersTotalGrand = dailyReports?.map(order => order.grandTotal)
    const grandTotal = ordersTotalGrand?.reduce((previousValue, currentValue) => previousValue + currentValue, 0)
    const axiosInstance = useAxiosInstance()
    console.log("🚀 ~ file: DailyReports.js:37 ~ DailyReports ~ grandTotal:", grandTotal)

    useEffect(() => {
        async function fetchAndDailyReports() {
            const { data } = await axiosInstance.get(ORDERS_API + "getDailyOrders")
            setDailyReports(data)
        }
        fetchAndDailyReports()
    }, [toggleFetch, axiosInstance])

    function handleClose() {
        setShowModal(false);
        setShowCreateForm(false);
        setShowViewSection(false);
        setShowUpdateForm(false);
        setShowDeleteSection(false);
    }
    function triggerFetch() {
        setToggleFetch(prevState => !prevState)
    }
    return (
        <>
            <div className='crud_holder'>
                <div className="body_header">
                    <h1 className="heading">{`Daily Orders (${dailyReports?.length} in total)`}</h1>
                    <h1 className="heading">{`Total Revenue (${grandTotal ? takaFormatter(grandTotal) : '0'})`}</h1>
                    {/* <CreateButton
                        screenTopicSingular='Orders'
                        setShowModal={setShowModal}
                        setShowCreateForm={setShowCreateForm}
                    /> */}
                </div>
                <CRUDTable>
                    <CRUDTableHeader>
                        <CRUDth th='Order Id' />
                        <CRUDth th='Status' />
                        <CRUDth th='Customer' />
                        <CRUDth th='Actions' />
                    </CRUDTableHeader>
                    <tbody>
                        {dailyReports?.map(dailyReport => (
                            <CRUDTableRow key={dailyReport._id}>
                                <ShortTextCell text={dailyReport._id} />
                                <ShortTextCell text={dailyReport.orderStatus} />
                                <ShortTextCell text={dailyReport.customer.name} />

                                <td className="action_button_cell">
                                    <ViewButton
                                        setShowModal={setShowModal}
                                        setShowViewSection={setShowViewSection}
                                        targetID={dailyReport._id}
                                        setTargetID={setTargetID}
                                    />
                                   
                                    {/* <DeleteButton
                                        setShowModal={setShowModal}
                                        setShowDeleteSection={setShowDeleteSection}
                                        targetID={item._id}
                                        setTargetID={setTargetID}
                                    /> */}


                                </td>
                            </CRUDTableRow>
                        ))}
                    </tbody>
                </CRUDTable>
            </div>
            {showModal &&
                <Modal
                    handleClose={handleClose}
                    modalHeading={
                        (showCreateForm && `Create Item`) ||
                        (showUpdateForm && `Update Item`) ||
                        (showDeleteSection && `Delete Item`)
                    }
                >
                    {/* {
                        showCreateForm &&
                        <CreateItem
                            employee={employee}
                            setShowCreateForm={setShowCreateForm}
                            setShowModal={setShowModal}
                            triggerFetch={triggerFetch}
                            restaurantID={parentID}
                        />
                    } */}
                    {/* {
                        showUpdateForm &&
                        <UpdateItem
                            employee={employee}
                            targetID={targetID}
                            setShowUpdateForm={setShowUpdateForm}
                            setShowModal={setShowModal}
                            triggerFetch={triggerFetch}
                        />
                    } */}
                    {
                        showDeleteSection &&
                        <CRUDDeleteBoilerPlate
                            api={ORDERS_API}
                            targetID={targetID}
                            employee={employee}
                            setShowModal={setShowModal}
                            setShowDeleteSection={setShowDeleteSection}
                            hasName
                            triggerFetch={triggerFetch}
                        />
                    }
                </Modal>
            }

            {showModal &&
                <Modal
                    handleClose={handleClose}
                    modalHeading={
                        (showViewSection && `View Order`)
                    }
                >
                    {
                        showViewSection &&
                        <ViewOrder
                            targetID={targetID}
                            employee={employee}
                        />
                    }
                </Modal>
            }
        </>
    )
}

export default DailyReports